import Notification from './Notification'
import NotificationContainer from './NotificationContainer'

export default NotificationContainer(Notification)
